import { ActionTypes } from '../actions/index';
import { IFetchStateAction } from '../actions/settings-fetch';
import { IExchangeTicket } from '../classes/ticket-exchange';

export interface IExchangeSettingsModel {
    exchangeTickets: Array<IExchangeTicket>,
    activeExchangeTickets: Array<IExchangeTicket>,
}

let defaultExchangeSettingsModel: IExchangeSettingsModel = {
    exchangeTickets: [],
    activeExchangeTickets: []
};

export { defaultExchangeSettingsModel };

export function exchangeSettingsModel(state: IExchangeSettingsModel = defaultExchangeSettingsModel, action: IFetchStateAction): IExchangeSettingsModel {
    switch (action.type) {
        case ActionTypes.LOAD_EXCHANGES:
            return { ...state, exchangeTickets: action.value };
        case ActionTypes.SET_CURRENT_EXCHANGE_TICKETS:
            return { ...state, activeExchangeTickets: action.value.exchangeTickets };
        default:
            return state
    }
}